import { VOBackground, VOExhibition } from "../model/DataStructure.js";
import { Background } from "./Background.js";
import { Selector, SelectorItemData } from "./Selector.js";

export interface HomeOptions {
    container: HTMLElement;
    exhibitions: VOExhibition[];
    assetsUrl: string;
    background: VOBackground;
    visible: boolean;
    title: string;
    onSelectExhibition: (item: VOExhibition) => void;
}

export class Home {

    private _element: HTMLDivElement;
    private _options: HomeOptions;
    private _selector: Selector<VOExhibition>;
    private _background: Background;

    constructor(options: HomeOptions) {
        options = e5.object.merge({
            visible: false
        }, options);
        this._options = options;

        this._element = document.createElement("div");
        this._element.className = "home base__panel base__panel--hidden";
        this._element.innerHTML = `
        <div class="home__background"></div>
        <div class="home__header">
            <div class="home__title-container">
                <div class="home__title">${options.title}</div>
            </div>
        </div>
        <div class="home__subline">Bremer Landesmuseum 
        für Kunst und Kulturgeschichte</div>
        <div class="home__body"></div>
        `;

        this._background = new Background({
            container: this._element.querySelector(".home__background"),
            data: options.background
        });

        const items: SelectorItemData<VOExhibition>[] = [];
        
        const exhibitions = this._options.exhibitions;
        for (let e of exhibitions) {

            let name = e.name;
            if (e.subline) {
                name += " -\n" + e.subline;
            }
            items.push({
                name: name,
                previewImage: e.preview_image_url,
                icon: "none",
                data: e
            })
        }

        this._selector = new Selector({
            container: this._element.querySelector(".home__body"),
            data: items,
            layout: "multiline",
            buttonSize: "large",
            onSelect: options.onSelectExhibition
        });

        this.visible = options.visible;

        options.container.appendChild(this._element);
    }

    public reset():void{
        this._selector.reset();
    }

    public get visible(): boolean {
        return !this._element.classList.contains("base__panel--hidden");
    }

    public set visible(value: boolean) {
        this._element.classList.toggle("base__panel--hidden", !value);
    }
}